import { gql } from '@apollo/client'
import { ApprovalDeal } from 'ts/interfaces/approvalDeal.interface'

export interface HomepageDealsResponse {
  homepageDeals: {
    errorCode?: string
    didError: boolean
    errorMessage?: string
    infoMessage?: string
    deals: ApprovalDeal[]
  }
}

export interface HomepageDealsRequest {
  userId: string
}

export const GET_PENDING_APPROVALS = gql`
  query HomepageDeals($userId: String!) {
    homepageDeals(userId: $userId) {
      errorCode
      didError
      errorMessage
      infoMessage
      deals {
        dealId
        dealNr
        dealVersion
        winLossStatus
        quoteStatus
        authStatus
        approvalStatus
        statusUpdateType
        countryCode
        countryName
        busModel
        businessUnit
        leadBusGroup
        engagementModel
        mcCode
        createDate
        submitDate
        timeSinceSubmit
        dealBeginDate
        dealEndDate
        bidDueTs
        processedDateGmt
        dealDescription
        workBucketId
        workBucketName
        dealTypeMapping
        customerName
        customerSegment
        currency
        estDealSizeNet
        estDealSizeList
        sentBy
        salesRep
        routeReason
        lockFlag
        lockUser
        dealLockedFor
        dealSource
        dealSourceId
        notes
        externalNotes
        highRisk
        highRiskDealEUVNotCompletedYet
        lastMessage
        msgTime
        dealLead
        distManagerName
        tenantId
        opportunityId
        stateProvince
        conflictCheckComplete
        completedGroup
        userDecision
        pendingLevel
        decisionPagePath
      }
    }
  }
`

export default GET_PENDING_APPROVALS
